import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-notification',
  templateUrl: './modal-notification.component.html',
  styleUrls: ['./modal-notification.component.scss']
})
export class ModalNotificationComponent implements OnInit {

  public messageText:string;
  
  constructor(@Inject(MAT_DIALOG_DATA) data,
              public dialogRef: MatDialogRef<ModalNotificationComponent>) { 
    this.messageText = data.message;
  }

  ngOnInit(): void {
  }

  closeModal()
  {
    this.dialogRef.close();
  }
}
